import * as React from "react";
import {DesignSystemProvider} from "@unibuddy/patron";
import * as Sentry from "@sentry/react";
import {ErrorReportingProvider, createSentryAdaptor} from "@unibuddy/error-reporting";
import {AnalyticsProvider} from "@unibuddy/tracking";
import mixpanelAdaptor from "@unibuddy/tracking/dist/adaptors/mixpanel";

import {Root} from "./Root";
import "./config.js";
import "./App.css";
import {ApiProvider} from "./providers/ApiProvider";
import {getenv} from "./utils/getenv";
import {theme} from "./utils/theme/theme";
import {getSentryEnv} from "./utils/getSentryEnv";
import {FeatureFlaggingProvider} from "./providers/FeatureFlaggingProvider";
import {UnibuddyImpressionsLogo} from "./components/UnibuddyImpressionsLogo/UnibuddyImpressionsLogo";
import {UniversityProvider} from "./providers/UniversityProvider";
import {PostMessageProvider} from "./providers/PostMessageProvider";

const VERSION = getenv("VERSION") ?? "v0.0.0";
const MIXPANEL_ID = getenv("MIXPANEL_ID") ?? "32664f8059425b4f34cda3841205c458";
const MIXPANEL_PROXY_HOST = getenv("MIXPANEL_PROXY_HOST") ?? "https://tukey.unibuddy.co";

const sentryConfig = {
    dsn: "https://df8dfeb42c58922dedc92c492ddb2027@o338736.ingest.sentry.io/4506020278501376",
    environment: getSentryEnv(getenv("UB_ENVIRONMENT")),
    release: `PROSPECT_GUIDANCE_${VERSION}`,
    ignoreErrors: [],
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.01,
    tracesSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.01,
};
Sentry.init(sentryConfig);
const sentryAdaptor = createSentryAdaptor({Sentry});

const App = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const universityId = urlParams.get("universityId");
    const universitySlug = urlParams.get("universitySlug");
    const analyticsEnabled = urlParams.get("analyticsEnabled") !== "false";
    const adaptors = [];

    if (analyticsEnabled) {
        mixpanelAdaptor.init(MIXPANEL_ID, {api_host: MIXPANEL_PROXY_HOST});
        adaptors.push(mixpanelAdaptor);
    }

    return (
        <FeatureFlaggingProvider>
            <ErrorReportingProvider adaptor={sentryAdaptor}>
                <ApiProvider
                    onLogout={() => {
                        console.log("Bye bye");
                    }}
                >
                    <DesignSystemProvider theme={theme}>
                        <UniversityProvider
                            universityId={universityId}
                            universitySlug={universitySlug}
                        >
                            <AnalyticsProvider adaptors={adaptors ?? []}>
                                <PostMessageProvider>
                                    <UnibuddyImpressionsLogo />
                                    <Root />
                                </PostMessageProvider>
                            </AnalyticsProvider>
                        </UniversityProvider>
                    </DesignSystemProvider>
                </ApiProvider>
            </ErrorReportingProvider>
        </FeatureFlaggingProvider>
    );
};

export default App;
